





















import Vue from 'vue'

import AdvantagesItem from './AdvantagesItem.vue'

export default Vue.extend({
  name: 'Advantages',
  components: {
    AdvantagesItem
  },
  props: {
    advantages: {
      type: Object,
      default() {
        return {}
      }
    },
    isNumbered: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    title(): string {
      return this.advantages.title
    }
  }
})
